import {
  RoleListModel,
  RolePayloadModel,
  RolesModel,
} from "@/domain/model/roles";

import { RoleFormModel } from "./components/RoleTabForm/useRoleForm";
import { permissionList } from "./permissionList";

export const countAllRolePermissions = (data: RoleListModel[]) => {
  let totalPermissions = 0;

  data.forEach((category) => {
    totalPermissions += category.permissions.length;
  });

  return totalPermissions;
};

export const formatRoleDataForm = (data: RoleFormModel): RolePayloadModel => {
  const { name, ...permissionsData } = data;
  const allPermissions = Object.values(permissionsData)
    .flat()
    .filter((permission) => permission != null);

  return {
    name: name,
    can_edit: true,
    can_delete: true,
    permissions: allPermissions || [],
  };
};

type ReverseFormatPermissionsInitialValues = {
  [key: string]: string[] | string;
};

export const reverseFormatPermissions = (
  data: RolesModel | undefined,
  assignedSubmissionOwner: boolean,
) => {
  if (!Object.keys(data || {}).length || !data) return {} as RoleFormModel;
  const initialValues: ReverseFormatPermissionsInitialValues = {
    name: data.name,
  };
  const permissions = data.permissions;

  Object.entries(permissionList(assignedSubmissionOwner)).forEach(
    ([key, value]) => {
      initialValues[key] = value.filter((permission) =>
        permissions?.includes(permission),
      );
    },
  );

  return initialValues as RoleFormModel;
};
